import { createFileRoute, redirect } from '@tanstack/react-router';
import { getAuthStore } from '../main';
import { SpSidebar } from '../components/Sidebar';
import { HStack, Pane } from '@sheridan-prize/ui';
import { UserList } from '../components/UsersListView';
import { Link } from '../components/Link';
import { MaterialSymbol, StateLayer } from '@moonjellydigital/react-components';

export const Route = createFileRoute('/users')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
    const isAuthenticated = getAuthStore().getIsAuthenticated();
    const userRole = getAuthStore().getUser()?.role;

    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    if (userRole !== 'superadmin' && userRole !== 'admin') {
      throw redirect({ to: '/' });
    }

    await getAuthStore().fetchUserDoc();
  },
  component: Users,
});

function Users() {
  return (
    <>
      <SpSidebar />
      <Pane tag="main" classes={'sp-main'}>
        <HStack gap="s4" align="center" padBlockEnd="s4">
          <h1 style={{ maxWidth: 'max-content', marginBlockStart: '0' }}>
            Users
          </h1>
          <Link
            to="/users/add"
            className={'mjd-button mjd-button_filled'}
            style={{ maxWidth: 'max-content', justifyContent: 'flex-start' }}
          >
            <StateLayer tag="span" />
            <MaterialSymbol icon="add" /> Add User
          </Link>
        </HStack>
        <UserList />
      </Pane>
    </>
  );
}
